/* stylelint-disable selector-no-qualifying-type */
/* stylelint-disable selector-max-compound-selectors */

:host {
  --modal-vertical-padding: #{rem(64)};
  @include reset-host;

  @include mq('max', 'md') {
    --modal-vertical-padding: #{rem(40)};
  }
}

:host .article-modal {
  @include z-index('header');
  position: relative;

  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
}

:host .backdrop {
  @include cover;

  display: block;

  background: rgba($black, 0.4);
  backdrop-filter: blur(2px);
}

:host .modal-header {
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding: rem(20) rem(33);

  @include mq('max', 'md') {
    padding: rem(10) $gutter;
  }

  .close-button {
    padding: 0;

    color: $white;

    background: transparent;
    border: 0;
    cursor: pointer;
  }
}

:host .content-wrapper {
  position: relative;
  z-index: 1;

  flex: 1;
  min-height: 0;
  padding: 0 $gutter;
  overflow: clip;

  background: $white;
  border-top-left-radius: rem(30);
  border-top-right-radius: rem(30);

  @include mq('max', 'md') {
    padding: 0 $gutter-mobile;

    border-top-left-radius: $gutter-mobile;
    border-top-right-radius: $gutter-mobile;
  }

  &:before,
  &:after {
    position: absolute;
    left: 0;
    z-index: 1;

    width: 100%;
    height: var(--modal-vertical-padding);

    content: '';
  }

  &:before {
    top: 0;

    background: linear-gradient(to bottom, rgba($white, 1), rgba($white, 0));
  }

  &:after {
    bottom: 0;

    background: linear-gradient(to top, rgba($white, 1), rgba($white, 0));
  }
}

:host .content {
  width: 100%;
  max-width: $max-width;
  height: 100%;
  margin: 0 auto;
  padding: var(--modal-vertical-padding) 0;

  overflow-y: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
}

:host .content-header {
  display: flex;
  gap: map-get($spacing-sizes, 4);
  align-items: center;
  min-height: rem(275);
  margin-bottom: map-get($spacing-sizes, 8);

  color: $white;

  border-radius: rem(8);

  @include mq('max', 'md') {
    gap: map-get($spacing-sizes, 2);
    min-height: unset;
    margin-bottom: map-get($spacing-sizes, 4);
  }

  @each $color-key, $color-value in $theme-colors {
    &.is-#{$color-key}-variant {
      background: map-get($color-value, default);
    }
  }
}

:host .header-text {
  flex: 1;
  padding: rem(47) rem(42);

  @include mq('max', 'md') {
    padding: rem(12) $gutter-mobile;

    &:not(.has-text-only) {
      padding-right: 0;
    }
  }

  &.has-text-only {
    text-align: center;
  }

  .title {
    display: block;
    margin-bottom: map-get($spacing-sizes, 1);
    padding-left: rem(5);

    font-weight: $fw-regular;
    font-size: rem(80);
    font-family: $ff-title;
    line-height: 1.1;

    @include mq('max', 'md') {
      font-size: rem(40);
    }
  }

  .subtitle {
    display: block;

    font-weight: $fw-regular;
    font-size: rem(40);
    line-height: 1.2;

    @include mq('max', 'md') {
      font-size: rem(20);
    }
  }
}

:host .header-image {
  @include mq('max', 'md') {
    display: flex;
    align-items: center;
    width: rem(120);
    height: rem(120);
  }
}

:host .content-main {
  position: relative;

  display: flex;
  gap: map-get($spacing-sizes, 4);

  @include mq('max', 'md') {
    flex-direction: column-reverse;
  }
}

:host .main-text {
  flex: 1;
  max-width: rem(640);

  h3,
  h4 {
    margin-bottom: map-get($spacing-sizes, 1);

    font-weight: $fw-bold;
    font-size: rem(22);
    line-height: 1.2;
  }

  h4 {
    font-size: $fs-lg;
  }

  h5 {
    margin-bottom: map-get($spacing-sizes, 1);

    font-weight: $fw-medium;
    font-size: $fs-base;
    line-height: 1.2;
  }

  p {
    margin-bottom: map-get($spacing-sizes, 2);

    &.intro {
      font-size: $fs-lg;
    }
  }

  ul {
    margin-bottom: map-get($spacing-sizes, 2);
    padding-left: rem(20);

    font-size: $fs-base;

    li {
      margin-bottom: map-get($spacing-sizes, 1);
    }
  }

  a {
    color: $color-purple;
    text-decoration: underline;
  }

  strong {
    color: $color-purple;
    font-weight: $fw-bold;
  }

  .tip-block {
    margin-top: map-get($spacing-sizes, 1);
    margin-bottom: map-get($spacing-sizes, 2);
    padding: 16px;

    color: $color-purple;

    background: #fef5ff;
    border: 1px solid $color-purple;
    border-radius: map-get($spacing-sizes, 2);
  }
}

:host .main-image-wrapper {
  min-width: rem(200);
  max-width: rem(445);
}

:host .main-image {
  position: sticky;
  top: 0;
}

:host .main-image-mobile {
  display: none;
  max-width: 100%;
  height: auto;
  margin: map-get($spacing-sizes, 2) 0;

  @include mq('max', 'md') {
    display: block;
  }
}

:host .content-footer {
  --title-color: #{$white};
  --paragraph-color: #{$white};

  display: flex;
  gap: map-get($spacing-sizes, 2);
  max-width: rem(640);
  margin-top: map-get($spacing-sizes, 8);

  background: $color-purple;
  border-radius: $radius-md;

  @include mq('max', 'md') {
    flex-direction: column;
    margin-top: map-get($spacing-sizes, 4);
  }

  .text-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: map-get($spacing-sizes, 4);
    align-items: flex-start;
    padding: 32px;
    padding-right: 0;

    @include mq('max', 'md') {
      padding: 16px;
    }
  }

  .image-wrapper {
    align-self: flex-end;
    max-height: 100%;
    padding-top: map-get($spacing-sizes, 1);

    @include mq('max', 'md') {
      align-self: center;
      max-width: rem(180);
    }
  }
}
